import { MessageService } from "./message.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { User } from "../models/user";
import { Url } from "../common/url";
import { Router } from "@angular/router";
import { Message } from "../common/message";
import { Enums } from "../common/enums";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private url: string = Url.user;

  constructor(
    private msg: MessageService,
    private http: HttpClient,
    private router: Router
  ) {}

  login(user: User) {
    return this.http.post(this.url + "/login?include=user", user);
  }

  checkActiveUser(result: any) {
    if (!(result && result.user && result.user.active)) {
      return false;
    }

    return true;
  }

  logout() {
    return this.http.post(this.url + "/logout", null).subscribe(
      (result) => {
        localStorage.setItem("userData", null);
        this.msg.alert(Message.SUCCESS_LOGOUT);
        this.goLogin();
        return true;
      },
      (err) => {
        localStorage.setItem("userData", null);
        this.goLogin();
        return true;
      }
    );
  }

  getUserData() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (userData && userData.id && userData.user) {
      return userData.user;
    } else {
      return null;
    }
  }

  getToken() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (userData && userData.id && userData.user) {
      return userData.id;
    } else {
      return null;
    }
  }

  getUserName() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (userData && userData.id && userData.user) {
      return userData.user.name;
    } else {
      return null;
    }
  }

  getUserRole() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (userData && userData.id && userData.user) {
      return userData.user.role;
    } else {
      return null;
    }
  }

  goLogin() {
    this.router.navigate(["/login"]);
  }

  private goHome() {
    this.router.navigate(["./home"]);
  }

  chkIfLoggedIn() {
    let b = this.isUserLoggedIn();
    if (b) {
      this.goHome();
    } else {
      this.goLogin();
    }
  }

  isUserLoggedIn() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (userData && userData.id && userData.user && userData.user.active) {
      return true;
    } else {
      return false;
    }
  }

  isSuperAdmin() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.superAdmin
    ) {
      return true;
    } else {
      return null;
    }
  }

  isQaDataEntry() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.dataentry_qa
    ) {
      return true;
    } else {
      return null;
    }
  }

  isQaAudit() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.audit_qa
    ) {
      return true;
    } else {
      return null;
    }
  }

  isQaManager() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.manager_qa
    ) {
      return true;
    } else {
      return null;
    }
  }

  isAdmin() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.admin
    ) {
      return true;
    } else {
      return null;
    }
  }

  isDataEntry() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.dataEntry
    ) {
      return true;
    } else {
      return null;
    }
  }

  isDataEntryQA() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.dataentry_qa
    ) {
      return true;
    } else {
      return null;
    }
  }

  isAudit() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.audit
    ) {
      return true;
    } else {
      return null;
    }
  }
  isAuditQA() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.audit_qa
    ) {
      return true;
    } else {
      return null;
    }
  }

  isStoreMan() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.stock
    ) {
      return true;
    } else {
      return null;
    }
  }

  isManager() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.manager
    ) {
      return true;
    } else {
      return null;
    }
  }

  isGeneralManager() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (
      userData &&
      userData.id &&
      userData.user &&
      userData.user.role == Enums.role.generalManager
    ) {
      return true;
    } else {
      return null;
    }
  }
}
